import { render, staticRenderFns } from "./PricingCard.vue?vue&type=template&id=c1af996a&scoped=true"
import script from "./PricingCard.vue?vue&type=script&lang=js"
export * from "./PricingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1af996a",
  null
  
)

export default component.exports